const FANDOM_ICONS = {
  'amazing world of gumball': '🌈',
  'arcane': '⚙️',
  'ateez': '🏴‍☠️',
  'attack on titan': '⚔️',
  'avatar the last airbender': '🌪️',
  'black clover': '🍀',
  'blue exorcist': '🔥',
  'bluey': '🐕',
  'bts rpf': '🎵',
  'creepypasta': '🔪',
  'danny phantom': '👻',
  'deltarune': '❤️',
  'demon slayer': '🗡️',
  'demonology roblox': '🎮',
  'dragon ball z': '🐉',
  'dungeons and dragons': '🎲',
  'electronic dance music rpf': '🎧',
  'euphoria': '✦',
  'final fantasy': '🔮',
  'food wars': '🍳',
  'formula one rpf': '🏎️',
  'gorillaz beatcats': '🦍',
  'greys anatomy': '🩺',
  'haikyuu': '🏐',
  'harry potter': '🪄',
  'hazbin hotel': '😈',
  'heathers': '🎪',
  'jigokuraku': '🌸',
  'jujutsu kaisen': '👁️',
  'keeper of the lost cities': '🗝️',
  'kuroshitsuji': '🎩',
  'legend of zelda': '🧝',
  'lord of the rings': '💍',
  'marvel': '🦸',
  'miraculous ladybug': '🐞',
  'my hero academia': '⚡',
  'my little pony friendship is magic': '🦄',
  'naruto': '🍥',
  'one direction': '🎤',
  'one piece': '☠️',
  'original fiction': '✍️',
  'other': '📖',
  'outer banks': '🌴',
  'percy jackson': '🔱',
  'project moon': '🌙',
  'resident evil': '🧟',
  'romance': '💕',
  'scream': '😱',
  'scrooge 2022': '🎄',
  'solo leveling': '⬆️',
  'spy x family': '🕵️',
  'star wars': '✨',
  'steven universe': '💎',
  'stranger things': '🔦',
  'stray kids rpf': '🐺',
  'supernatural': '🪬',
  'taylor swift rpf': '🎸',
  'the case study of vanitas': '🦇',
  'the handmaids tale': '📕',
  'the hunger games': '🏹',
  'the resurrectionist a rae dunlap': '🪦',
  'tokyo ghoul': '👤',
  'twilight': '🌒',
  'undertale': '💀',
  'vampire diaries': '🩸',
  'various': '🎭',
  'wednesday': '🕷️',
  'yandere': '💔',
  'yandere simulator': '🎀',
}

function normalize(name) {
  return (name ?? '').toLowerCase().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, ' ').trim()
}

export function getFandomIcon(name) {
  const key = normalize(name)
  if (FANDOM_ICONS[key]) return FANDOM_ICONS[key]
  for (const [k, v] of Object.entries(FANDOM_ICONS)) {
    if (key.startsWith(k) || k.startsWith(key)) return v
  }
  return null
}
